import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerLanguageResolverService } from './customer-language-resolver.service';
import { LanguageResolver } from './language-resolver';
import { BranchCustom1Resolver } from './language-resolvers/branch-custom1-resolver';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [CustomerLanguageResolverService,
    {
    provide: LanguageResolver,
    useExisting: BranchCustom1Resolver,
    multi: true,
  }],
})
export class CustomerLanguageResolverModule {}
